export default __webpack_public_path__ + "static/area-with-negative-values-17af386df76bd35a282371d6c4e07650.png";